
import { formatCurrencyFloat } from "@/plugins/filters";
import { get } from "lodash";
import Vue from "vue";

export default Vue.extend({
  name: "PolicyEndorsementCoverage",
  props: {
    policyInquiryData: {
      type: Object
    }
  },
  methods: {
    endorsementAndDescription(type: "title" | "limits" | "premium"): string[] {
      const title: string[] = [];
      const limits: string[] = [];
      const premium: string[] = [];

      const endorLst: Record<string, string> = get(
        this.policyInquiryData,
        "endorLst",
        {}
      );
      const endobje: Record<string, [number, any, any?]> = get(
        this.policyInquiryData,
        "Endor",
        {}
      );
      const endor: [string, [number, any, any?]][] = Object.entries(endobje);

      const formatLimit = (key: string, value: [number, any, any?]): string => {
        const val1 = value[1];
        const val2 = value[2];

        if (["255", "215"].includes(key)) {
          return val1 || "";
        }

        if (["022", "145"].includes(key)) {
          return val1 != 0
            ? formatCurrencyFloat(val1)
              ? `Class${val2} ${val1} %`
              : ""
            : "&nbsp;";
        }

        if (["135", "026", "027"].includes(key)) {
          return val1 ? `${val1} %` : "";
        }

        if (["017 RENT 1", "018 RENT 2"].includes(key)) {
          return formatCurrencyFloat(val1) ? `Class${val2}-${val1}` : "";
        }

        return val1 ? formatCurrencyFloat(val1) : "";
      };

      endor.forEach(([key, value]) => {
        title.push(endorLst[key] || "");
        limits.push(formatLimit(key, value));
        premium.push(value[0] ? formatCurrencyFloat(value[0]) : "$0.00");
      });

      // Add PropSchedPrem if exists
      const propSchedPrem = get(this.policyInquiryData, "PropSchedPrem");
      if (propSchedPrem) {
        title.push("HO-160A Schedule Personal Property");

        const total = get(this.policyInquiryData, "PropSchedTotal");
        limits.push(total ? formatCurrencyFloat(total) : "");

        premium.push(formatCurrencyFloat(propSchedPrem));
      }

      // Final total
      title.push("Premium from All Endorsements");
      limits.push("");
      premium.push(formatCurrencyFloat(get(this.policyInquiryData, "End_Tot")));

      switch (type) {
        case "title":
          return title;
        case "limits":
          return limits;
        default:
          return premium;
      }
    }
  },
  computed: {
    endorsementTitle(): string[] {
      return this.endorsementAndDescription("title");
    },
    endorsementLimits(): string[] {
      return this.endorsementAndDescription("limits");
    },
    endorsementPremiums(): string[] {
      return this.endorsementAndDescription("premium");
    }
  }
});
